export enum PropertyChatE {
  QUEUE = 'queue',
  IN_QUEUE = 'in_queue',
  CHATS = 'chats',
  FINISHED = 'finished',
  ARCHIVED = 'archived',
  FLOW = 'flow',
  WORKFLOW = 'workflow',
  INTERNAL = 'internal',
  KANBAN = 'kanban',
  API = 'api',
  DELAYED = 'delayed',
  WAITING = 'waiting',
}
